import React, { useState } from 'react';
import { Form, Button, Spinner, Alert } from 'react-bootstrap';

function ReviewForm({ onSubmit, isLoading }) {
  const [formData, setFormData] = useState({
    name: '',
    role: '',
    content: '',
    rating: 5
  });
  
  const [validated, setValidated] = useState(false);
  const [formError, setFormError] = useState(null);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  
  const handleRatingChange = (selectedRating) => {
    setFormData({
      ...formData,
      rating: selectedRating
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setFormError(null);
    
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    
    // Validate content length
    if (formData.content.length < 10) {
      setFormError("Please provide a more detailed review (at least 10 characters).");
      return;
    }
    
    setValidated(true);
    onSubmit({
      ...formData,
      date: new Date().toISOString() // Add the current date
    });
  };
  
  // Render the star rating input
  const renderRatingInput = () => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <i
          key={i}
          className={`fa ${i <= formData.rating ? 'fa-star' : 'fa-star-o'}`}
          style={{ 
            color: '#f4a111', 
            fontSize: '24px', 
            margin: '0 5px',
            cursor: 'pointer' 
          }}
          onClick={() => handleRatingChange(i)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              handleRatingChange(i);
            }
          }}
          tabIndex={0}
          role="button"
          aria-label={`Rate ${i} stars`}
        ></i>
      );
    }
    return stars;
  };
  
  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      {formError && (
        <Alert 
          variant="danger" 
          className="mb-3"
          style={{
            backgroundColor: 'rgba(244, 67, 54, 0.1)',
            color: '#f44336',
            border: '1px solid rgba(244, 67, 54, 0.3)'
          }}
        >
          {formError}
        </Alert>
      )}
      
      <Form.Group controlId="reviewName" className="mb-3">
        <Form.Label style={{ color: '#f4a111', fontWeight: 'bold' }}>Your Name</Form.Label>
        <Form.Control
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Enter your name"
          required
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            color: '#fff',
            border: '1px solid rgba(244, 161, 17, 0.3)',
            padding: '12px 15px'
          }}
        />
        <Form.Control.Feedback type="invalid">
          Please provide your name.
        </Form.Control.Feedback>
      </Form.Group>
      
      <Form.Group controlId="reviewRole" className="mb-3">
        <Form.Label style={{ color: '#f4a111', fontWeight: 'bold' }}>Your Experience Level</Form.Label>
        <Form.Control
          as="select"
          name="role"
          value={formData.role}
          onChange={handleChange}
          required
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            color: '#fff',
            border: '1px solid rgba(244, 161, 17, 0.3)',
            padding: '12px 15px',
            paddingRight: '2.5rem',
            appearance: 'auto',
            WebkitAppearance: 'menulist',
            MozAppearance: 'menulist'
          }}
          className="review-select"
        >
          <option value="" disabled={formData.role !== ''}>Select your experience level</option>
          <option value="Beginner">Beginner</option>
          <option value="Regular Member">Regular Member</option>
          <option value="Advanced Practitioner">Advanced Practitioner</option>
        </Form.Control>
        <Form.Control.Feedback type="invalid">
          Please select your experience level.
        </Form.Control.Feedback>
      </Form.Group>
      
      <Form.Group controlId="reviewContent" className="mb-3">
        <Form.Label style={{ color: '#f4a111', fontWeight: 'bold' }}>Your Review</Form.Label>
        <Form.Control
          as="textarea"
          name="content"
          value={formData.content}
          onChange={handleChange}
          rows={4}
          placeholder="Share your experience with our yoga classes..."
          required
          minLength={10}
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            color: '#fff',
            border: '1px solid rgba(244, 161, 17, 0.3)',
            padding: '12px 15px'
          }}
          className="review-textarea"
        />
        
      </Form.Group>
      
      <Form.Group controlId="reviewRating" className="mb-4">
        <Form.Label style={{ color: '#f4a111', fontWeight: 'bold' }}>Your Rating</Form.Label>
        <div className="rating-input text-center mb-3">
          {renderRatingInput()}
        </div>
      </Form.Group>
      
      <div className="d-grid mt-4">
        <Button 
          type="submit" 
          variant="warning" 
          size="lg"
          disabled={isLoading}
          style={{
            backgroundColor: '#f4a111',
            color: '#ffffff',
            fontWeight: 'bold',
            border: 'none',
            borderRadius: '8px',
            padding: '15px',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)'
          }}
        >
          {isLoading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Submitting...
            </>
          ) : 'Submit Review'}
        </Button>
      </div>
    </Form>
  );
}

export default ReviewForm;
